import chalk from "chalk";
import type { Verdict } from "../core/types.js";

export function printVerdict(verdict: Verdict, format: string): void {
  if (format === "json") {
    console.log(JSON.stringify(verdict, null, 2));
    return;
  }
  if (format === "verdict-only") {
    console.log(verdict.verdict);
    return;
  }

  // Pretty terminal output.
  const color = verdictColor(verdict.verdict);
  const line = "─".repeat(60);

  console.log();
  console.log(chalk.gray(line));
  console.log(
    chalk.bold.magenta("PULSE PROTOCOL ") + chalk.gray("·") + chalk.gray(` v${verdict.version}`)
  );
  console.log(chalk.gray(line));
  console.log();
  console.log(
    chalk.gray("target:   ") + chalk.white(`@${verdict.target.handle}`)
  );
  console.log(
    chalk.gray("wallet:   ") +
      chalk.white(verdict.target.wallet.slice(0, 8) + "..." + verdict.target.wallet.slice(-4))
  );
  console.log(
    chalk.gray("scanned:  ") +
      chalk.white(new Date(verdict.scanned_at * 1000).toISOString())
  );
  console.log();
  console.log(chalk.gray("signals:"));
  console.log(
    `  ${chalk.gray("cadence     ")} ${bar(verdict.signals.posting_cadence)} ${chalk.white(verdict.signals.posting_cadence)}`
  );
  console.log(
    `  ${chalk.gray("onchain     ")} ${bar(verdict.signals.onchain_cadence)} ${chalk.white(verdict.signals.onchain_cadence)}`
  );
  console.log(
    `  ${chalk.gray("voice       ")} ${bar(verdict.signals.voice_consistency)} ${chalk.white(verdict.signals.voice_consistency)}`
  );
  console.log(
    `  ${chalk.gray("timing      ")} ${chalk.white(verdict.signals.timing_anomalies)} anomalies`
  );
  console.log(
    `  ${chalk.gray("correlation ")} ${bar(verdict.signals.correlation)} ${chalk.white(verdict.signals.correlation)}`
  );
  console.log();
  console.log(chalk.gray(line));
  console.log(
    "verdict:  " +
      color(chalk.bold(verdict.verdict)) +
      chalk.gray(
        `  (${(verdict.confidence * 100).toFixed(0)}% confidence, aggregate ${verdict.aggregate_score}/100)`
      )
  );
  console.log(chalk.gray(line));
  console.log();
}

function verdictColor(v: string) {
  if (v === "AUTONOMOUS") return chalk.magenta;
  if (v === "HYBRID") return chalk.magentaBright;
  return chalk.gray;
}

function bar(value: number): string {
  const width = 20;
  const filled = Math.round((value / 100) * width);
  const empty = width - filled;
  return chalk.magenta("█".repeat(filled)) + chalk.gray("░".repeat(empty));
}
